import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { ImportationSucceedComponent } from '../importation-succeed/importation-succeed.component';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { IFallbackValues, IMatchingColumn, IMatchingErrorsResponse, INameCreateEnabledFields, IOdoofield, IResponseMatching, IRowsErrorMessage, IRowsErrorsResponse } from '../../models/imports.models';
import { Observable, Subscription, tap } from 'rxjs';
import { Router } from '@angular/router';
import { MatchingColumns, MatchingColumnsError, MatchingColumnsSuccess, ReImportProducts, ReImportProductsSuccess } from '../../store/imports.actions';
import { Actions, ofType } from '@ngrx/effects';
import { MatStepper } from '@angular/material/stepper';
import { PreviewErrorsComponent } from '../preview-errors/preview-errors.component';
import { CommonService } from 'src/app/shared/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-upload-processing',
  templateUrl: './upload-processing.component.html',
  styleUrls: ['./upload-processing.component.scss']
})
export class UploadProcessingComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper | undefined;
  mode: ProgressBarMode = 'determinate';
  value = 79;
  fileReady: boolean = false;
  responseMatching$: Observable<IResponseMatching | null> = this.store.select((state) => state.importProducts.responseMatching);
  responseMatching!: IResponseMatching;
  selectedValues: string[] = [];
  subscriptions: Subscription[] = [];
  matchingErrorsResponse: IMatchingErrorsResponse | null = null;
  rowsErrorsResponse: IRowsErrorsResponse | null = null;
  productsImport: any[] = [];
  columns: string[] = [];
  fields: string[] = [];
  name_create_enabled_fields: { [key: string]: boolean } = {};
  fallback_values: IFallbackValues = {};
  file_name!: string;
  showMoreErrors: boolean = false;
  decimal_separator: string = 'EU';
  selectedSheet: string = '';
  filteredFields: IOdoofield[] = [];
  constructor(
    private dialog: MatDialog,
    private store: Store<AppState>,
    private router: Router,
    private actions$: Actions,
    private cdr: ChangeDetectorRef,
    private commonService: CommonService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    const sub1 = this.responseMatching$.subscribe((res) => {
      if (res) {
        this.responseMatching = res;
        this.selectedValues = res.data.columns.map((column) => {
          const foundField = res.data.fields.find(
            (field) => column.toLocaleLowerCase() === field.string.toLocaleLowerCase()
          );
          return foundField ? foundField.name : '';
        });

        const { fields } = this.responseMatching.data
        this.filteredFields = fields.filter(f => !this.selectedValues.includes(f.name));

        this.file_name = res.data.file_name;
        this.selectedSheet = res.data.sheets[0];
      } else {
        this.back();
      }
    });

    const sub2 = this.actions$.pipe(
      ofType(MatchingColumnsError),
      tap((action) => {
        if (action.responseMatching) {
          const response = action.responseMatching;
          if (this.isMatchingErrorsResponse(response)) {
            if (this.stepper) {
              this.stepper.reset();
              this.stepper.selectedIndex = 1;
              this.cdr.detectChanges();
            }
          } else if (this.isRowsErrorsResponse(response)) {
            if (this.stepper) {
              this.rowsErrorsResponse = response;
              this.matchingErrorsResponse = null;
              this.stepper.selectedIndex = 2;
              this.cdr.detectChanges();
            }
          }
        }
      })
    ).subscribe();


    const sub3 = this.actions$.pipe(
      ofType(MatchingColumnsSuccess),
      tap((action) => {
        if (action.test && action.executeSeccess.preview.products) {
          this.rowsErrorsResponse = null
          this.productsImport = action.executeSeccess.preview.products;
          if (action.executeSeccess.matches) {
            this.columns = action.executeSeccess.matches.columns;
            this.fields = action.executeSeccess.matches.fields;
          }
          this.stepper!.selectedIndex = 2;
        }
        else if (!action.test) {
          this.dialog.open(ImportationSucceedComponent, {
            data: this.productsImport
          })
        }
      })).subscribe();

    const sub4 = this.actions$.pipe(
      ofType(ReImportProductsSuccess),
      tap((action) => {
        this.file_name = action.responseMatching.data.file_name
        this.testAndResolve()
      })).subscribe();

    this.subscriptions.push(sub1, sub2, sub3, sub4);
  }

  ngAfterViewInit(): void {
    if (this.stepper) {
      this.stepper.selectedIndex = 1;
      this.cdr.detectChanges();
    }
  }


  isMatchingErrorsResponse(
    response: IMatchingErrorsResponse | IRowsErrorsResponse
  ): response is IMatchingErrorsResponse {
    return Array.isArray((response as IMatchingErrorsResponse).messages) &&
      (response as IMatchingErrorsResponse).messages[0]?.not_matching_error !== undefined;
  }

  // Type guard for IRowsErrorsResponse
  isRowsErrorsResponse(
    response: IMatchingErrorsResponse | IRowsErrorsResponse
  ): response is IRowsErrorsResponse {
    return (response as IRowsErrorsResponse).ids !== undefined;
  }

  setSelectedValue(index: number, event: any) {
    const valueSelected = event.target.value;
    this.selectedValues = this.selectedValues.map((value: string, i: number) => {
      if (i !== index && value === valueSelected) {
        return '';
      } else {
        return value
      }
    })

    const { fields } = this.responseMatching.data
    this.filteredFields = fields.filter(f => !this.selectedValues.includes(f.name));
  }

  missedColomns(columns: string[], selected: string[]): number {
    const columnsLength = columns.length;
    const selectedLength = selected.filter((col) => col !== '').length;
    return columnsLength - selectedLength;
  }

  selectedColomnsPercentage(columns: string[], selected: string[]): number {
    const columnsLength = columns.length;
    const selectedLength = selected.filter((col) => col !== '').length;
    return (selectedLength / columnsLength) * 100;
  }

  isRelationError(field: string): boolean {
    return field ? field.endsWith('_id') || field.endsWith('_ids') || field === 'current_supplier' : false;
  }

  setSolution(error: IRowsErrorMessage, event: any) {
    const value = event.target.value;
    if (value === 'create_new_values') {
      this.name_create_enabled_fields[error.field] = true;
      if (this.fallback_values[error.field]) {
        delete this.fallback_values[error.field];
      }
    } else {
      this.name_create_enabled_fields[error.field] = false;
      this.fallback_values[error.field] = {
        fallback_value: 'prevent',
        field_model: error.moreinfo.res_model,
        field_type: 'many2one'
      };
    }
  }

  viewErrorContent(error: IRowsErrorMessage, rowsErrorsResponse: IRowsErrorsResponse) {
    this.dialog.open(PreviewErrorsComponent, {
      data: {
        error: error,
        rowsErrorsResponse: rowsErrorsResponse
      },
      width: '80%'
    });
  }

  testAndResolve(): boolean | void {
    if (!this.selectedSheet) {
      this.commonService.showToast(
        this.translateService.instant('alerts.import.no.sheet'),
        'WARNING'
      );
      return false
    }
    if (
      this.selectedValues.every(value => value !== null && value !== undefined)
      && this.selectedValues.length === this.responseMatching.data.columns.length
      && this.selectedValues.includes('sku')
      && this.selectedValues.includes('name')
    ) {
      this.name_create_enabled_fields = Object.fromEntries(
        Object.entries(this.name_create_enabled_fields)
          .filter(([key, value]) => value === true)
      );
      const data: IMatchingColumn = {
        test: true,
        columns: this.responseMatching.data.columns,
        fields: this.selectedValues,
        name_create_enabled_fields: this.name_create_enabled_fields,
        fallback_values: this.fallback_values,
        sheet: this.selectedSheet,
        sheets: this.responseMatching?.data?.sheets ?? [this.selectedSheet],
        decimal_separator: this.decimal_separator
      };
      this.store.dispatch(MatchingColumns({ id: this.responseMatching.id, matchingColumns: data }));
      this.selectedValues = [...this.selectedValues];
      this.name_create_enabled_fields = { ...this.name_create_enabled_fields };
      this.fallback_values = { ...this.fallback_values };
    }
    else {
      this.commonService.showToast(
        this.translateService.instant('alerts.import.match.error'),
        'WARNING'
      );
      return false
    }
  }

  reaploadFile(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('ufile', file ?? '');
        this.store.dispatch(ReImportProducts({ id: this.responseMatching.id, file: formData }));
      }
    }
    // clear the input file
    event.target.value = '';
  }

  getFieldIndex(fieldName: string): string {
    const index = this.fields.indexOf(fieldName);
    return index !== -1 ? this.columns[index] : '';
  }

  saveAsDraft() {
    this.back();
  }

  commit() {
    const data: IMatchingColumn = {
      test: false,
      columns: this.responseMatching.data.columns,
      fields: this.selectedValues,
      sheet: this.selectedSheet,
      sheets: this.responseMatching?.data?.sheets ?? [this.selectedSheet],
      name_create_enabled_fields: this.name_create_enabled_fields,
      decimal_separator: this.decimal_separator
    };
    this.store.dispatch(MatchingColumns({ id: this.responseMatching.id, matchingColumns: data }));
    this.selectedValues = [...this.selectedValues];
  };

  back() {
    this.router.navigate(['imports'], {
      queryParamsHandling: 'merge',
    })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }
}
